import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

export interface CartItem {
  id: number;
  type?: string;
  name: string;
  price: number;
  promotion_id?: number;
  is_promo?: boolean;
  selected?: boolean;
  productCode?: string;
  description?: string;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class CartService {
  private readonly STORAGE_KEY = 'bizzbean_cart';
  
  private cartItems: CartItem[] = [];

  private cartItemsSubject = new BehaviorSubject<CartItem[]>(this.cartItems);
  public cartItems$: Observable<CartItem[]> = this.cartItemsSubject.asObservable();

  constructor(
    private router: Router,
    private http: HttpClient

  ) {
    this.loadCartFromStorage();
  }

  private loadCartFromStorage(): void {
    try {
      const storedCart = localStorage.getItem(this.STORAGE_KEY);
      if (storedCart) {
        this.cartItems = JSON.parse(storedCart);
        this.cartItemsSubject.next([...this.cartItems]);
      } else {
        // If no stored cart, initialize with default item
        this.cartItems = [];
        this.saveCartToStorage();
        this.cartItemsSubject.next([...this.cartItems]);
      }
    } catch (error) {
      console.error('Error loading cart from localStorage:', error);
      // Fallback to default if parsing fails
      this.cartItems = [];
      this.saveCartToStorage();
      this.cartItemsSubject.next([...this.cartItems]);
    }
  }

  private saveCartToStorage(): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.cartItems));
    } catch (error) {
      console.error('Error saving cart to localStorage:', error);
    }
  }

  getCartItems(): CartItem[] {
    return this.cartItems;
  }

  addToCart(item: CartItem, app:String='', type:string='app'): void {
    const existingItem = this.cartItems.find(cartItem => cartItem.name === item.heading);
    if (!existingItem) {

      this.cartItems.push({
        id: item.id,
        name: item.heading,
        price: item.sellingPrice,
        selected: false,
        productCode: item.productCode,
        type: type,
        promotion_id: item.promotion_id || null,
        is_promo: item.is_promo || false,
      });
      this.cartItemsSubject.next([...this.cartItems]);
      this.saveCartToStorage();

      Swal.fire(
        {
          text: app + ' added to cart',
          icon: 'success',
          confirmButtonColor: '#9fc754',
          draggable: true
        }
      )
    }
  }

  removeFromCart(itemName: string): void {
    this.cartItems = this.cartItems.filter(item => item.name !== itemName);
    this.cartItemsSubject.next([...this.cartItems]);
    this.saveCartToStorage();
  }

  updateItemSelection(itemName: string, selected: boolean): void {
    const item = this.cartItems.find(cartItem => cartItem.name === itemName);
    if (item) {
      item.selected = selected;
      this.cartItemsSubject.next([...this.cartItems]);
      this.saveCartToStorage();
    }
  }

  getTotal(): number {
    return this.cartItems
      .reduce((sum, item) => sum + Number(item.price), 0);
  }

  getVat(): number {
    // VAT is calculated as 15% of the total (South African VAT rate)
    const total = this.getTotal();
    return (total * 0.15) / 1.15; // VAT-inclusive calculation
  }

  removeSelectedItems(): void {
    this.cartItems = this.cartItems.filter(item => item.selected === false || item.selected === undefined);
    this.cartItemsSubject.next([...this.cartItems]);
    this.saveCartToStorage();
  }

  clearCart(): void {
    this.cartItems = [];
    this.cartItemsSubject.next([]);
    this.saveCartToStorage();
  }


    async checkout(body:any): Promise<any[]> {

      let headers = new HttpHeaders({
            x_api_key: environment.XKEY_static_files,
            Authorization: `Bearer ${sessionStorage.getItem('sessionToken')}`,
      });
      const data: any = await this.http
        .post<any[]>(`${environment.static_image_url}/api/payments/payfast/init`, body, {
          headers: headers,
        })
        .toPromise();
      return data
    }
}
